import { css } from "@emotion/react";

const styles = {
  Logo: css`
    cursor: pointer;
    max-width: 15rem;
  `
}

export default styles;